import { useEffect } from "react";

/**
 * Injects a JSON-LD <script> into <head> for SEO structured data.
 * Cleans up on unmount / data change.
 */
export const JsonLd = ({ id, data }) => {
  useEffect(() => {
    const scriptId = `jsonld-${id}`;
    let el = document.getElementById(scriptId);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = scriptId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const node = document.getElementById(scriptId);
      if (node) node.remove();
    };
  }, [id, data]);

  return null;
};
